
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(196|212|574|949)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
